<template>
  <header>
    <h1>ActivAir</h1>
    <h2>Find fresh air for your outdoor activities.</h2>
  </header>
</template>

<script>export default { name: 'Header' }</script>

<style src='./Header.css'></style>
